<template>
  <div class="row">
    <div class="col-md-12 px-gap">
      <div class="card card-default bg-white no-margin widget-loader-bar rounded shade">
        <div class="card-header top-left top-right">
          <span class="h6">{{ title }}</span>
          <div class="card-controls" v-if="value_copy != ''">
            <i class="bi bi-copy clickable hoverable h6" title="Copy" @click="doCopy">
            </i>
          </div>
        </div>
        <div class="card-body p-t-40">
          <div class="row">
            <div class="col-sm-12">
              <h4 class="no-margin p-b-5 text-danger semi-bold">
                <slot />
              </h4>
              <div v-if="use_footer">
                <div v-for="(footer_data, index) in footer" :key="'footer-data-' + index"
                  class="d-flex align-items-center pull-left small" :class="[{ 'm-l-20': index > 0 }]">
                  <span style="text-transform: uppercase">{{
                    footer_data.name
                  }}</span>
                  <span class="text-success">
                    <i class="pg-icon m-l-10" />
                  </span>
                  <span class="text-success">
                    {{ footer_data.value }}
                  </span>
                </div>
              </div>
              <div class="clearfix" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "score_card",
  props: {
    title: {
      type: String,
      default: function () {
        return "";
      },
    },
    value_copy: {
      type: String,
      default: "",
    },
    use_footer: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    footer: {
      type: Array,
      default: function () {
        return [
          {
            name: "AVG",
            value: "2k",
          },
        ];
      },
    },
  },
  methods: {
    doCopy: function () {
      this.$copyText(this.value_copy).then(
        () => {
          this.$("body")
            .pgNotification({
              style: "bar",
              message: '<i class="bi bi-clipboard-check"></i> <b>Copied!</b>!',
              position: "top-right",
              timeout: 5000,
              type: "success",
            })
            .show();
        },
        function () {
          this.$("body")
            .pgNotification({
              style: "bar",
              message: '<i class="bi bi-x-circle"></i> <b>Failed to copy!</b>!',
              position: "top-right",
              timeout: 5000,
              type: "danger",
            })
            .show();
        }
      );
    },
  },
};
</script>
